import PromotionSaleApproveSection from './PromotionSaleApproveSection'
import { withPromotionSaleApproveSection } from './withPromotionSaleApproveSection'

const ConnectedPromotionSaleApproveSection = withPromotionSaleApproveSection(
  PromotionSaleApproveSection
)

export { ConnectedPromotionSaleApproveSection as PromotionSaleApproveSection }
